export default {
    en: {
        accountDetails: 'Account details',
        communicationPreferences: 'Communication preferences',
        paymentPreferences: 'Payment preferences',
        firstName: 'First name',
        lastName: 'Last name',
        username: 'Username',
        contactEmail: 'Contact email',
        mobile: 'Mobile',
        internationalDiallingCode: 'International dialling code',
        pleaseSelect: 'Please select',
        commsViaWhatsApp: 'I want to receive activities to complete via WhatsApp',
        commsViaEmail: 'I want to receive email newsletters and updates as part of {communityName}',
        mobileNumberHint: 'Enter a local number or a full international number. We normalize using your selected country dialling code.',
        preferredPaymentMethod: 'Preferred payment method:',
        paymentEmail: 'Payment email',
        saveChanges: 'Save changes',
        viewPaymentRecords: 'View record of payments',
        paymentRecordsTitle: 'Record of payments',
        loadingPaymentRecords: 'Loading records',
        paymentsTableTitle: 'Payments',
        errorGettingUserDetails: 'Error getting user details',
        errorUpdatingProfile: 'Error updating profile',
        profileUpdated: 'Profile updated',
        manageAccount: 'Manage account',
        closeAccountIntro: 'If you no longer wish to take part in {communityName}, request to',
        closeAccountLink: 'close your account here',
        closeAccountGracePeriod: 'You will have a month from the date of request to re-activate your account before it is removed.',
        accountDueToClose: 'Your account is due to be closed on {date},',
        cancelClosureLink: 'cancel the closure here',
        closeAccountHeader: 'Close your account',
        closeAccountConfirmMessage: 'Are you sure you want to close your account?',
        closeAccountConfirmButton: 'Close',
        cancel: 'Cancel',
        errorClosingAccount: 'Error closing account',
        requestCloseAccountReceived: 'Request to close account received',
        errorCancellingClosure: 'Error cancelling closure of account',
        requestCancelClosureReceived: 'Request to cancel closure of account received',
    },
    in: {
        accountDetails: 'Detail akun',
        communicationPreferences: 'Preferensi komunikasi',
        paymentPreferences: 'Preferensi pembayaran',
        firstName: 'Nama depan',
        lastName: 'Nama belakang',
        username: 'Nama pengguna',
        contactEmail: 'Email kontak',
        mobile: 'Ponsel',
        internationalDiallingCode: 'Kode panggilan internasional',
        pleaseSelect: 'Silakan pilih',
        commsViaWhatsApp: 'Saya ingin menerima aktivitas untuk diselesaikan melalui WhatsApp',
        commsViaEmail: 'Saya ingin menerima buletin email dan pembaruan sebagai bagian dari {communityName}',
        mobileNumberHint: 'Masukkan nomor lokal atau nomor internasional lengkap. Kami menormalkan menggunakan kode panggilan negara yang Anda pilih.',
        preferredPaymentMethod: 'Metode pembayaran pilihan:',
        paymentEmail: 'Email pembayaran',
        saveChanges: 'Simpan perubahan',
        viewPaymentRecords: 'Lihat catatan pembayaran',
        paymentRecordsTitle: 'Catatan pembayaran',
        loadingPaymentRecords: 'Memuat catatan',
        paymentsTableTitle: 'Pembayaran',
        errorGettingUserDetails: 'Gagal mengambil detail pengguna',
        errorUpdatingProfile: 'Gagal memperbarui profil',
        profileUpdated: 'Profil diperbarui',
        manageAccount: 'Kelola akun',
        closeAccountIntro: 'Jika Anda tidak lagi ingin berpartisipasi di {communityName}, ajukan permintaan untuk',
        closeAccountLink: 'menutup akun Anda di sini',
        closeAccountGracePeriod: 'Anda memiliki satu bulan sejak tanggal permintaan untuk mengaktifkan kembali akun sebelum dihapus.',
        accountDueToClose: 'Akun Anda akan ditutup pada {date},',
        cancelClosureLink: 'batalkan penutupan di sini',
        closeAccountHeader: 'Tutup akun Anda',
        closeAccountConfirmMessage: 'Apakah Anda yakin ingin menutup akun Anda?',
        closeAccountConfirmButton: 'Tutup',
        cancel: 'Batal',
        errorClosingAccount: 'Gagal menutup akun',
        requestCloseAccountReceived: 'Permintaan penutupan akun diterima',
        errorCancellingClosure: 'Gagal membatalkan penutupan akun',
        requestCancelClosureReceived: 'Permintaan pembatalan penutupan akun diterima',
    },
    zh: {
        accountDetails: '账户详情',
        communicationPreferences: '通信偏好',
        paymentPreferences: '付款偏好',
        firstName: '名',
        lastName: '姓',
        username: '用户名',
        contactEmail: '联系邮箱',
        mobile: '手机',
        internationalDiallingCode: '国际区号',
        pleaseSelect: '请选择',
        commsViaWhatsApp: '我希望通过 WhatsApp 接收待完成的活动',
        commsViaEmail: '我希望作为 {communityName} 的一部分接收电子邮件通讯和更新',
        mobileNumberHint: '请输入本地号码或完整的国际号码。我们将根据您选择的国家区号进行规范化。',
        preferredPaymentMethod: '首选付款方式：',
        paymentEmail: '付款邮箱',
        saveChanges: '保存更改',
        viewPaymentRecords: '查看付款记录',
        paymentRecordsTitle: '付款记录',
        loadingPaymentRecords: '正在加载记录',
        paymentsTableTitle: '付款',
        errorGettingUserDetails: '获取用户详情时出错',
        errorUpdatingProfile: '更新个人资料时出错',
        profileUpdated: '个人资料已更新',
        manageAccount: '管理账户',
        closeAccountIntro: '如果您不再希望参与 {communityName}，请申请',
        closeAccountLink: '在此关闭您的账户',
        closeAccountGracePeriod: '从申请之日起，您有一个月的时间重新激活账户，之后账户将被删除。',
        accountDueToClose: '您的账户将于 {date} 关闭，',
        cancelClosureLink: '在此取消关闭',
        closeAccountHeader: '关闭您的账户',
        closeAccountConfirmMessage: '您确定要关闭账户吗？',
        closeAccountConfirmButton: '关闭',
        cancel: '取消',
        errorClosingAccount: '关闭账户时出错',
        requestCloseAccountReceived: '已收到关闭账户的请求',
        errorCancellingClosure: '取消关闭账户时出错',
        requestCancelClosureReceived: '已收到取消关闭账户的请求',
    },
    nl: {
        accountDetails: 'Accountgegevens',
        communicationPreferences: 'Communicatievoorkeuren',
        paymentPreferences: 'Betalingsvoorkeuren',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        username: 'Gebruikersnaam',
        contactEmail: 'Contact-e-mail',
        mobile: 'Mobiel',
        internationalDiallingCode: 'Internationale landcode',
        pleaseSelect: 'Selecteer',
        commsViaWhatsApp: 'Ik wil activiteiten ontvangen om via WhatsApp te voltooien',
        commsViaEmail: 'Ik wil e-mailnieuwsbrieven en updates ontvangen als onderdeel van {communityName}',
        mobileNumberHint: 'Voer een lokaal nummer of een volledig internationaal nummer in. We normaliseren dit met uw geselecteerde landcode.',
        preferredPaymentMethod: 'Voorkeursbetaalmethode:',
        paymentEmail: 'Betalings-e-mail',
        saveChanges: 'Wijzigingen opslaan',
        viewPaymentRecords: 'Betalingsgeschiedenis bekijken',
        paymentRecordsTitle: 'Betalingsgeschiedenis',
        loadingPaymentRecords: 'Records laden',
        paymentsTableTitle: 'Betalingen',
        errorGettingUserDetails: 'Fout bij ophalen gebruikersgegevens',
        errorUpdatingProfile: 'Fout bij bijwerken profiel',
        profileUpdated: 'Profiel bijgewerkt',
        manageAccount: 'Account beheren',
        closeAccountIntro: 'Als u niet langer wilt deelnemen aan {communityName}, vraag dan aan om',
        closeAccountLink: 'uw account hier te sluiten',
        closeAccountGracePeriod: 'U heeft een maand vanaf de aanvraagdatum om uw account te heractiveren voordat het wordt verwijderd.',
        accountDueToClose: 'Uw account wordt gesloten op {date},',
        cancelClosureLink: 'annuleer de sluiting hier',
        closeAccountHeader: 'Sluit uw account',
        closeAccountConfirmMessage: 'Weet u zeker dat u uw account wilt sluiten?',
        closeAccountConfirmButton: 'Sluiten',
        cancel: 'Annuleren',
        errorClosingAccount: 'Fout bij sluiten account',
        requestCloseAccountReceived: 'Verzoek om account te sluiten ontvangen',
        errorCancellingClosure: 'Fout bij annuleren van accountsluiting',
        requestCancelClosureReceived: 'Verzoek om accountsluiting te annuleren ontvangen',
    },
    fi: {
        accountDetails: 'Tilin tiedot',
        communicationPreferences: 'Viestintäasetukset',
        paymentPreferences: 'Maksuasetukset',
        firstName: 'Etunimi',
        lastName: 'Sukunimi',
        username: 'Käyttäjänimi',
        contactEmail: 'Yhteyshenkilön sähköposti',
        mobile: 'Matkapuhelin',
        internationalDiallingCode: 'Kansainvälinen suuntanumero',
        pleaseSelect: 'Valitse',
        commsViaWhatsApp: 'Haluan vastaanottaa tehtäviä suoritettavaksi WhatsAppin kautta',
        commsViaEmail: 'Haluan vastaanottaa sähköpostiuutiskirjeitä ja päivityksiä osana yhteisöä {communityName}',
        mobileNumberHint: 'Syötä paikallinen numero tai täysi kansainvälinen numero. Normalisoimme sen valitsemasi maan suuntanumeron mukaan.',
        preferredPaymentMethod: 'Ensisijainen maksutapa:',
        paymentEmail: 'Maksusähköposti',
        saveChanges: 'Tallenna muutokset',
        viewPaymentRecords: 'Näytä maksutiedot',
        paymentRecordsTitle: 'Maksutiedot',
        loadingPaymentRecords: 'Ladataan tietueita',
        paymentsTableTitle: 'Maksut',
        errorGettingUserDetails: 'Virhe käyttäjätietojen haussa',
        errorUpdatingProfile: 'Virhe profiilin päivityksessä',
        profileUpdated: 'Profiili päivitetty',
        manageAccount: 'Hallitse tiliä',
        closeAccountIntro: 'Jos et enää halua osallistua yhteisöön {communityName}, pyydä',
        closeAccountLink: 'tilisi sulkemista täältä',
        closeAccountGracePeriod: 'Sinulla on kuukausi pyyntöpäivästä tilisi uudelleenaktivointiin ennen poistamista.',
        accountDueToClose: 'Tilisi suljetaan {date},',
        cancelClosureLink: 'peruuta sulkeminen täältä',
        closeAccountHeader: 'Sulje tilisi',
        closeAccountConfirmMessage: 'Haluatko varmasti sulkea tilisi?',
        closeAccountConfirmButton: 'Sulje',
        cancel: 'Peruuta',
        errorClosingAccount: 'Virhe tilin sulkemisessa',
        requestCloseAccountReceived: 'Tilin sulkemispyyntö vastaanotettu',
        errorCancellingClosure: 'Virhe tilin sulkemisen peruutuksessa',
        requestCancelClosureReceived: 'Tilin sulkemisen peruutuspyyntö vastaanotettu',
    },
    fr: {
        accountDetails: 'Détails du compte',
        communicationPreferences: 'Préférences de communication',
        paymentPreferences: 'Préférences de paiement',
        firstName: 'Prénom',
        lastName: 'Nom',
        username: "Nom d'utilisateur",
        contactEmail: 'E-mail de contact',
        mobile: 'Mobile',
        internationalDiallingCode: 'Indicatif international',
        pleaseSelect: 'Veuillez sélectionner',
        commsViaWhatsApp: 'Je souhaite recevoir des activités à compléter via WhatsApp',
        commsViaEmail: 'Je souhaite recevoir des newsletters et des mises à jour par e-mail dans le cadre de {communityName}',
        mobileNumberHint: 'Saisissez un numéro local ou un numéro international complet. Nous le normalisons selon l\'indicatif du pays sélectionné.',
        preferredPaymentMethod: 'Mode de paiement préféré :',
        paymentEmail: 'E-mail de paiement',
        saveChanges: 'Enregistrer les modifications',
        viewPaymentRecords: 'Voir l\'historique des paiements',
        paymentRecordsTitle: 'Historique des paiements',
        loadingPaymentRecords: 'Chargement des enregistrements',
        paymentsTableTitle: 'Paiements',
        errorGettingUserDetails: 'Erreur lors de la récupération des détails utilisateur',
        errorUpdatingProfile: 'Erreur lors de la mise à jour du profil',
        profileUpdated: 'Profil mis à jour',
        manageAccount: 'Gérer le compte',
        closeAccountIntro: 'Si vous ne souhaitez plus participer à {communityName}, demandez de',
        closeAccountLink: 'fermer votre compte ici',
        closeAccountGracePeriod: 'Vous aurez un mois à compter de la demande pour réactiver votre compte avant sa suppression.',
        accountDueToClose: 'Votre compte sera fermé le {date},',
        cancelClosureLink: 'annulez la fermeture ici',
        closeAccountHeader: 'Fermer votre compte',
        closeAccountConfirmMessage: 'Êtes-vous sûr de vouloir fermer votre compte ?',
        closeAccountConfirmButton: 'Fermer',
        cancel: 'Annuler',
        errorClosingAccount: 'Erreur lors de la fermeture du compte',
        requestCloseAccountReceived: 'Demande de fermeture de compte reçue',
        errorCancellingClosure: 'Erreur lors de l\'annulation de la fermeture du compte',
        requestCancelClosureReceived: 'Demande d\'annulation de fermeture de compte reçue',
    },
    de: {
        accountDetails: 'Kontodetails',
        communicationPreferences: 'Kommunikationseinstellungen',
        paymentPreferences: 'Zahlungseinstellungen',
        firstName: 'Vorname',
        lastName: 'Nachname',
        username: 'Benutzername',
        contactEmail: 'Kontakt-E-Mail',
        mobile: 'Mobil',
        internationalDiallingCode: 'Internationale Vorwahl',
        pleaseSelect: 'Bitte auswählen',
        commsViaWhatsApp: 'Ich möchte Aktivitäten per WhatsApp erhalten',
        commsViaEmail: 'Ich möchte E-Mail-Newsletter und Updates als Teil von {communityName} erhalten',
        mobileNumberHint: 'Geben Sie eine lokale oder vollständige internationale Nummer ein. Wir normalisieren sie anhand Ihrer gewählten Landesvorwahl.',
        preferredPaymentMethod: 'Bevorzugte Zahlungsmethode:',
        paymentEmail: 'Zahlungs-E-Mail',
        saveChanges: 'Änderungen speichern',
        viewPaymentRecords: 'Zahlungsverlauf anzeigen',
        paymentRecordsTitle: 'Zahlungsverlauf',
        loadingPaymentRecords: 'Datensätze werden geladen',
        paymentsTableTitle: 'Zahlungen',
        errorGettingUserDetails: 'Fehler beim Abrufen der Benutzerdetails',
        errorUpdatingProfile: 'Fehler beim Aktualisieren des Profils',
        profileUpdated: 'Profil aktualisiert',
        manageAccount: 'Konto verwalten',
        closeAccountIntro: 'Wenn Sie nicht mehr an {communityName} teilnehmen möchten, beantragen Sie',
        closeAccountLink: 'hier die Schließung Ihres Kontos',
        closeAccountGracePeriod: 'Sie haben ab dem Antragsdatum einen Monat Zeit, Ihr Konto zu reaktivieren, bevor es entfernt wird.',
        accountDueToClose: 'Ihr Konto wird am {date} geschlossen,',
        cancelClosureLink: 'heben Sie die Schließung hier auf',
        closeAccountHeader: 'Konto schließen',
        closeAccountConfirmMessage: 'Sind Sie sicher, dass Sie Ihr Konto schließen möchten?',
        closeAccountConfirmButton: 'Schließen',
        cancel: 'Abbrechen',
        errorClosingAccount: 'Fehler beim Schließen des Kontos',
        requestCloseAccountReceived: 'Antrag auf Kontoschließung erhalten',
        errorCancellingClosure: 'Fehler beim Aufheben der Kontoschließung',
        requestCancelClosureReceived: 'Antrag auf Aufhebung der Kontoschließung erhalten',
    },
    hi: {
        accountDetails: 'खाता विवरण',
        communicationPreferences: 'संचार प्राथमिकताएँ',
        paymentPreferences: 'भुगतान प्राथमिकताएँ',
        firstName: 'पहला नाम',
        lastName: 'अंतिम नाम',
        username: 'उपयोगकर्ता नाम',
        contactEmail: 'संपर्क ईमेल',
        mobile: 'मोबाइल',
        internationalDiallingCode: 'अंतर्राष्ट्रीय डायलिंग कोड',
        pleaseSelect: 'कृपया चुनें',
        commsViaWhatsApp: 'मैं WhatsApp के माध्यम से पूर्ण करने के लिए गतिविधियाँ प्राप्त करना चाहता/चाहती हूँ',
        commsViaEmail: 'मैं {communityName} का हिस्सा बनकर ईमेल न्यूज़लेटर और अपडेट प्राप्त करना चाहता/चाहती हूँ',
        mobileNumberHint: 'स्थानीय या पूर्ण अंतर्राष्ट्रीय नंबर दर्ज करें। हम आपके चयनित देश के डायलिंग कोड का उपयोग करके इसे सामान्य करते हैं।',
        preferredPaymentMethod: 'पसंदीदा भुगतान विधि:',
        paymentEmail: 'भुगतान ईमेल',
        saveChanges: 'परिवर्तन सहेजें',
        viewPaymentRecords: 'भुगतान रिकॉर्ड देखें',
        paymentRecordsTitle: 'भुगतान रिकॉर्ड',
        loadingPaymentRecords: 'रिकॉर्ड लोड हो रहे हैं',
        paymentsTableTitle: 'भुगतान',
        errorGettingUserDetails: 'उपयोगकर्ता विवरण प्राप्त करने में त्रुटि',
        errorUpdatingProfile: 'प्रोफ़ाइल अपडेट करने में त्रुटि',
        profileUpdated: 'प्रोफ़ाइल अपडेट की गई',
        manageAccount: 'खाता प्रबंधित करें',
        closeAccountIntro: 'यदि आप अब {communityName} में भाग नहीं लेना चाहते, तो अनुरोध करें',
        closeAccountLink: 'यहाँ अपना खाता बंद करने के लिए',
        closeAccountGracePeriod: 'हटाए जाने से पहले अनुरोध की तिथि से एक महीने का समय आपके पास खाता पुनः सक्रिय करने के लिए होगा।',
        accountDueToClose: 'आपका खाता {date} को बंद होने वाला है,',
        cancelClosureLink: 'यहाँ बंद करना रद्द करें',
        closeAccountHeader: 'अपना खाता बंद करें',
        closeAccountConfirmMessage: 'क्या आप वाकई अपना खाता बंद करना चाहते हैं?',
        closeAccountConfirmButton: 'बंद करें',
        cancel: 'रद्द करें',
        errorClosingAccount: 'खाता बंद करने में त्रुटि',
        requestCloseAccountReceived: 'खाता बंद करने का अनुरोध प्राप्त हुआ',
        errorCancellingClosure: 'खाता बंद करना रद्द करने में त्रुटि',
        requestCancelClosureReceived: 'खाता बंद करना रद्द करने का अनुरोध प्राप्त हुआ',
    },
    it: {
        accountDetails: 'Dettagli account',
        communicationPreferences: 'Preferenze di comunicazione',
        paymentPreferences: 'Preferenze di pagamento',
        firstName: 'Nome',
        lastName: 'Cognome',
        username: 'Nome utente',
        contactEmail: 'Email di contatto',
        mobile: 'Cellulare',
        internationalDiallingCode: 'Prefisso internazionale',
        pleaseSelect: 'Seleziona',
        commsViaWhatsApp: 'Voglio ricevere attività da completare tramite WhatsApp',
        commsViaEmail: 'Voglio ricevere newsletter e aggiornamenti via email come parte di {communityName}',
        mobileNumberHint: 'Inserisci un numero locale o un numero internazionale completo. Lo normalizziamo usando il prefisso del paese selezionato.',
        preferredPaymentMethod: 'Metodo di pagamento preferito:',
        paymentEmail: 'Email di pagamento',
        saveChanges: 'Salva modifiche',
        viewPaymentRecords: 'Visualizza storico pagamenti',
        paymentRecordsTitle: 'Storico pagamenti',
        loadingPaymentRecords: 'Caricamento record',
        paymentsTableTitle: 'Pagamenti',
        errorGettingUserDetails: 'Errore nel recupero dei dettagli utente',
        errorUpdatingProfile: 'Errore nell\'aggiornamento del profilo',
        profileUpdated: 'Profilo aggiornato',
        manageAccount: 'Gestisci account',
        closeAccountIntro: 'Se non desideri più partecipare a {communityName}, richiedi di',
        closeAccountLink: 'chiudere il tuo account qui',
        closeAccountGracePeriod: 'Avrai un mese dalla data della richiesta per riattivare il tuo account prima che venga rimosso.',
        accountDueToClose: 'Il tuo account verrà chiuso il {date},',
        cancelClosureLink: 'annulla la chiusura qui',
        closeAccountHeader: 'Chiudi il tuo account',
        closeAccountConfirmMessage: 'Sei sicuro di voler chiudere il tuo account?',
        closeAccountConfirmButton: 'Chiudi',
        cancel: 'Annulla',
        errorClosingAccount: 'Errore nella chiusura dell\'account',
        requestCloseAccountReceived: 'Richiesta di chiusura account ricevuta',
        errorCancellingClosure: 'Errore nell\'annullamento della chiusura dell\'account',
        requestCancelClosureReceived: 'Richiesta di annullamento chiusura account ricevuta',
    },
    ja: {
        accountDetails: 'アカウント詳細',
        communicationPreferences: '連絡設定',
        paymentPreferences: '支払い設定',
        firstName: '名',
        lastName: '姓',
        username: 'ユーザー名',
        contactEmail: '連絡先メール',
        mobile: '携帯電話',
        internationalDiallingCode: '国際ダイヤルコード',
        pleaseSelect: '選択してください',
        commsViaWhatsApp: 'WhatsAppで完了するアクティビティを受け取りたい',
        commsViaEmail: '{communityName} の一員としてメールニュースレターと更新を受け取りたい',
        mobileNumberHint: '国内番号または完全な国際番号を入力してください。選択した国のダイヤルコードを使用して正規化します。',
        preferredPaymentMethod: '希望の支払い方法：',
        paymentEmail: '支払い用メール',
        saveChanges: '変更を保存',
        viewPaymentRecords: '支払い記録を表示',
        paymentRecordsTitle: '支払い記録',
        loadingPaymentRecords: '記録を読み込み中',
        paymentsTableTitle: '支払い',
        errorGettingUserDetails: 'ユーザー詳細の取得エラー',
        errorUpdatingProfile: 'プロフィール更新エラー',
        profileUpdated: 'プロフィールを更新しました',
        manageAccount: 'アカウント管理',
        closeAccountIntro: '{communityName} への参加を終了したい場合は、',
        closeAccountLink: 'こちらからアカウントを閉鎖してください',
        closeAccountGracePeriod: '削除される前に、申請日から1か月以内にアカウントを再有効化できます。',
        accountDueToClose: 'アカウントは {date} に閉鎖予定です。',
        cancelClosureLink: 'こちらから閉鎖をキャンセル',
        closeAccountHeader: 'アカウントを閉鎖',
        closeAccountConfirmMessage: 'アカウントを閉鎖してもよろしいですか？',
        closeAccountConfirmButton: '閉鎖',
        cancel: 'キャンセル',
        errorClosingAccount: 'アカウント閉鎖エラー',
        requestCloseAccountReceived: 'アカウント閉鎖リクエストを受け付けました',
        errorCancellingClosure: 'アカウント閉鎖のキャンセルエラー',
        requestCancelClosureReceived: 'アカウント閉鎖キャンセルリクエストを受け付けました',
    },
    ko: {
        accountDetails: '계정 정보',
        communicationPreferences: '커뮤니케이션 설정',
        paymentPreferences: '결제 설정',
        firstName: '이름',
        lastName: '성',
        username: '사용자 이름',
        contactEmail: '연락처 이메일',
        mobile: '휴대전화',
        internationalDiallingCode: '국제 전화 코드',
        pleaseSelect: '선택하세요',
        commsViaWhatsApp: 'WhatsApp으로 완료할 활동을 받고 싶습니다',
        commsViaEmail: '{communityName}의 일원으로 이메일 뉴스레터와 업데이트를 받고 싶습니다',
        mobileNumberHint: '국내 번호 또는 전체 국제 번호를 입력하세요. 선택한 국가 전화 코드를 사용해 정규화합니다.',
        preferredPaymentMethod: '선호 결제 방법:',
        paymentEmail: '결제 이메일',
        saveChanges: '변경 사항 저장',
        viewPaymentRecords: '결제 기록 보기',
        paymentRecordsTitle: '결제 기록',
        loadingPaymentRecords: '기록 로딩 중',
        paymentsTableTitle: '결제',
        errorGettingUserDetails: '사용자 정보를 가져오는 중 오류 발생',
        errorUpdatingProfile: '프로필 업데이트 중 오류 발생',
        profileUpdated: '프로필이 업데이트되었습니다',
        manageAccount: '계정 관리',
        closeAccountIntro: '{communityName} 참여를 더 이상 원하지 않으면',
        closeAccountLink: '여기에서 계정 폐쇄를 요청하세요',
        closeAccountGracePeriod: '삭제되기 전에 요청일로부터 한 달 이내에 계정을 다시 활성화할 수 있습니다.',
        accountDueToClose: '계정이 {date}에 폐쇄될 예정입니다.',
        cancelClosureLink: '여기에서 폐쇄를 취소하세요',
        closeAccountHeader: '계정 폐쇄',
        closeAccountConfirmMessage: '계정을 폐쇄하시겠습니까?',
        closeAccountConfirmButton: '폐쇄',
        cancel: '취소',
        errorClosingAccount: '계정 폐쇄 오류',
        requestCloseAccountReceived: '계정 폐쇄 요청이 접수되었습니다',
        errorCancellingClosure: '계정 폐쇄 취소 오류',
        requestCancelClosureReceived: '계정 폐쇄 취소 요청이 접수되었습니다',
    },
    pl: {
        accountDetails: 'Szczegóły konta',
        communicationPreferences: 'Preferencje komunikacji',
        paymentPreferences: 'Preferencje płatności',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        username: 'Nazwa użytkownika',
        contactEmail: 'E-mail kontaktowy',
        mobile: 'Telefon komórkowy',
        internationalDiallingCode: 'Międzynarodowy numer kierunkowy',
        pleaseSelect: 'Wybierz',
        commsViaWhatsApp: 'Chcę otrzymywać aktywności do wykonania przez WhatsApp',
        commsViaEmail: 'Chcę otrzymywać newslettery i aktualizacje e-mail jako część {communityName}',
        mobileNumberHint: 'Wprowadź numer lokalny lub pełny numer międzynarodowy. Normalizujemy go według wybranego numeru kierunkowego kraju.',
        preferredPaymentMethod: 'Preferowana metoda płatności:',
        paymentEmail: 'E-mail do płatności',
        saveChanges: 'Zapisz zmiany',
        viewPaymentRecords: 'Zobacz historię płatności',
        paymentRecordsTitle: 'Historia płatności',
        loadingPaymentRecords: 'Ładowanie rekordów',
        paymentsTableTitle: 'Płatności',
        errorGettingUserDetails: 'Błąd pobierania danych użytkownika',
        errorUpdatingProfile: 'Błąd aktualizacji profilu',
        profileUpdated: 'Profil zaktualizowany',
        manageAccount: 'Zarządzaj kontem',
        closeAccountIntro: 'Jeśli nie chcesz już uczestniczyć w {communityName}, poproś o',
        closeAccountLink: 'zamknięcie konta tutaj',
        closeAccountGracePeriod: 'Masz miesiąc od daty wniosku na ponowną aktywację konta przed jego usunięciem.',
        accountDueToClose: 'Twoje konto zostanie zamknięte {date},',
        cancelClosureLink: 'anuluj zamknięcie tutaj',
        closeAccountHeader: 'Zamknij konto',
        closeAccountConfirmMessage: 'Czy na pewno chcesz zamknąć konto?',
        closeAccountConfirmButton: 'Zamknij',
        cancel: 'Anuluj',
        errorClosingAccount: 'Błąd zamykania konta',
        requestCloseAccountReceived: 'Otrzymano prośbę o zamknięcie konta',
        errorCancellingClosure: 'Błąd anulowania zamknięcia konta',
        requestCancelClosureReceived: 'Otrzymano prośbę o anulowanie zamknięcia konta',
    },
    pt: {
        accountDetails: 'Detalhes da conta',
        communicationPreferences: 'Preferências de comunicação',
        paymentPreferences: 'Preferências de pagamento',
        firstName: 'Nome',
        lastName: 'Apelido',
        username: 'Nome de utilizador',
        contactEmail: 'Email de contacto',
        mobile: 'Telemóvel',
        internationalDiallingCode: 'Indicativo internacional',
        pleaseSelect: 'Selecione',
        commsViaWhatsApp: 'Quero receber atividades para concluir via WhatsApp',
        commsViaEmail: 'Quero receber newsletters e atualizações por email como parte de {communityName}',
        mobileNumberHint: 'Introduza um número local ou internacional completo. Normalizamos usando o indicativo do país selecionado.',
        preferredPaymentMethod: 'Método de pagamento preferido:',
        paymentEmail: 'Email de pagamento',
        saveChanges: 'Guardar alterações',
        viewPaymentRecords: 'Ver registo de pagamentos',
        paymentRecordsTitle: 'Registo de pagamentos',
        loadingPaymentRecords: 'A carregar registos',
        paymentsTableTitle: 'Pagamentos',
        errorGettingUserDetails: 'Erro ao obter detalhes do utilizador',
        errorUpdatingProfile: 'Erro ao atualizar perfil',
        profileUpdated: 'Perfil atualizado',
        manageAccount: 'Gerir conta',
        closeAccountIntro: 'Se já não quiser participar em {communityName}, solicite',
        closeAccountLink: 'encerrar a sua conta aqui',
        closeAccountGracePeriod: 'Terá um mês a partir da data do pedido para reativar a conta antes de ser removida.',
        accountDueToClose: 'A sua conta será encerrada em {date},',
        cancelClosureLink: 'cancele o encerramento aqui',
        closeAccountHeader: 'Encerrar a sua conta',
        closeAccountConfirmMessage: 'Tem a certeza de que deseja encerrar a sua conta?',
        closeAccountConfirmButton: 'Encerrar',
        cancel: 'Cancelar',
        errorClosingAccount: 'Erro ao encerrar conta',
        requestCloseAccountReceived: 'Pedido de encerramento de conta recebido',
        errorCancellingClosure: 'Erro ao cancelar encerramento da conta',
        requestCancelClosureReceived: 'Pedido de cancelamento de encerramento recebido',
    },
    es: {
        accountDetails: 'Detalles de la cuenta',
        communicationPreferences: 'Preferencias de comunicación',
        paymentPreferences: 'Preferencias de pago',
        firstName: 'Nombre',
        lastName: 'Apellido',
        username: 'Nombre de usuario',
        contactEmail: 'Correo de contacto',
        mobile: 'Móvil',
        internationalDiallingCode: 'Prefijo internacional',
        pleaseSelect: 'Seleccione',
        commsViaWhatsApp: 'Quiero recibir actividades para completar por WhatsApp',
        commsViaEmail: 'Quiero recibir boletines y actualizaciones por correo como parte de {communityName}',
        mobileNumberHint: 'Introduce un número local o internacional completo. Lo normalizamos usando el prefijo del país seleccionado.',
        preferredPaymentMethod: 'Método de pago preferido:',
        paymentEmail: 'Correo de pago',
        saveChanges: 'Guardar cambios',
        viewPaymentRecords: 'Ver registro de pagos',
        paymentRecordsTitle: 'Registro de pagos',
        loadingPaymentRecords: 'Cargando registros',
        paymentsTableTitle: 'Pagos',
        errorGettingUserDetails: 'Error al obtener los datos del usuario',
        errorUpdatingProfile: 'Error al actualizar el perfil',
        profileUpdated: 'Perfil actualizado',
        manageAccount: 'Gestionar cuenta',
        closeAccountIntro: 'Si ya no deseas participar en {communityName}, solicita',
        closeAccountLink: 'cerrar tu cuenta aquí',
        closeAccountGracePeriod: 'Tendrás un mes desde la fecha de solicitud para reactivar tu cuenta antes de que se elimine.',
        accountDueToClose: 'Tu cuenta se cerrará el {date},',
        cancelClosureLink: 'cancela el cierre aquí',
        closeAccountHeader: 'Cerrar tu cuenta',
        closeAccountConfirmMessage: '¿Seguro que quieres cerrar tu cuenta?',
        closeAccountConfirmButton: 'Cerrar',
        cancel: 'Cancelar',
        errorClosingAccount: 'Error al cerrar la cuenta',
        requestCloseAccountReceived: 'Solicitud de cierre de cuenta recibida',
        errorCancellingClosure: 'Error al cancelar el cierre de la cuenta',
        requestCancelClosureReceived: 'Solicitud de cancelación de cierre recibida',
    },
    tr: {
        accountDetails: 'Hesap bilgileri',
        communicationPreferences: 'İletişim tercihleri',
        paymentPreferences: 'Ödeme tercihleri',
        firstName: 'Ad',
        lastName: 'Soyad',
        username: 'Kullanıcı adı',
        contactEmail: 'İletişim e-postası',
        mobile: 'Mobil',
        internationalDiallingCode: 'Uluslararası arama kodu',
        pleaseSelect: 'Lütfen seçin',
        commsViaWhatsApp: 'WhatsApp üzerinden tamamlanacak etkinlikler almak istiyorum',
        commsViaEmail: '{communityName} kapsamında e-posta bültenleri ve güncellemeler almak istiyorum',
        mobileNumberHint: 'Yerel veya tam uluslararası bir numara girin. Seçtiğiniz ülke arama kodunu kullanarak normalleştiririz.',
        preferredPaymentMethod: 'Tercih edilen ödeme yöntemi:',
        paymentEmail: 'Ödeme e-postası',
        saveChanges: 'Değişiklikleri kaydet',
        viewPaymentRecords: 'Ödeme kayıtlarını görüntüle',
        paymentRecordsTitle: 'Ödeme kayıtları',
        loadingPaymentRecords: 'Kayıtlar yükleniyor',
        paymentsTableTitle: 'Ödemeler',
        errorGettingUserDetails: 'Kullanıcı bilgileri alınırken hata oluştu',
        errorUpdatingProfile: 'Profil güncellenirken hata oluştu',
        profileUpdated: 'Profil güncellendi',
        manageAccount: 'Hesabı yönet',
        closeAccountIntro: 'Artık {communityName} katılımına devam etmek istemiyorsanız,',
        closeAccountLink: 'hesabınızı buradan kapatmayı talep edin',
        closeAccountGracePeriod: 'Silinmeden önce talep tarihinden itibaren bir ay içinde hesabınızı yeniden etkinleştirebilirsiniz.',
        accountDueToClose: 'Hesabınız {date} tarihinde kapatılacak,',
        cancelClosureLink: 'kapatmayı buradan iptal edin',
        closeAccountHeader: 'Hesabınızı kapatın',
        closeAccountConfirmMessage: 'Hesabınızı kapatmak istediğinizden emin misiniz?',
        closeAccountConfirmButton: 'Kapat',
        cancel: 'İptal',
        errorClosingAccount: 'Hesap kapatılırken hata oluştu',
        requestCloseAccountReceived: 'Hesap kapatma talebi alındı',
        errorCancellingClosure: 'Hesap kapatma iptali sırasında hata oluştu',
        requestCancelClosureReceived: 'Hesap kapatma iptal talebi alındı',
    },
    vi: {
        accountDetails: 'Chi tiết tài khoản',
        communicationPreferences: 'Tùy chọn liên lạc',
        paymentPreferences: 'Tùy chọn thanh toán',
        firstName: 'Tên',
        lastName: 'Họ',
        username: 'Tên người dùng',
        contactEmail: 'Email liên hệ',
        mobile: 'Di động',
        internationalDiallingCode: 'Mã quay số quốc tế',
        pleaseSelect: 'Vui lòng chọn',
        commsViaWhatsApp: 'Tôi muốn nhận hoạt động để hoàn thành qua WhatsApp',
        commsViaEmail: 'Tôi muốn nhận bản tin email và cập nhật như một phần của {communityName}',
        mobileNumberHint: 'Nhập số địa phương hoặc số quốc tế đầy đủ. Chúng tôi chuẩn hóa bằng mã quay số quốc gia bạn chọn.',
        preferredPaymentMethod: 'Phương thức thanh toán ưu tiên:',
        paymentEmail: 'Email thanh toán',
        saveChanges: 'Lưu thay đổi',
        viewPaymentRecords: 'Xem hồ sơ thanh toán',
        paymentRecordsTitle: 'Hồ sơ thanh toán',
        loadingPaymentRecords: 'Đang tải hồ sơ',
        paymentsTableTitle: 'Thanh toán',
        errorGettingUserDetails: 'Lỗi khi lấy thông tin người dùng',
        errorUpdatingProfile: 'Lỗi khi cập nhật hồ sơ',
        profileUpdated: 'Đã cập nhật hồ sơ',
        manageAccount: 'Quản lý tài khoản',
        closeAccountIntro: 'Nếu bạn không còn muốn tham gia {communityName}, hãy yêu cầu',
        closeAccountLink: 'đóng tài khoản tại đây',
        closeAccountGracePeriod: 'Bạn có một tháng kể từ ngày yêu cầu để kích hoạt lại tài khoản trước khi bị xóa.',
        accountDueToClose: 'Tài khoản của bạn sẽ bị đóng vào {date},',
        cancelClosureLink: 'hủy đóng tài khoản tại đây',
        closeAccountHeader: 'Đóng tài khoản',
        closeAccountConfirmMessage: 'Bạn có chắc muốn đóng tài khoản không?',
        closeAccountConfirmButton: 'Đóng',
        cancel: 'Hủy',
        errorClosingAccount: 'Lỗi khi đóng tài khoản',
        requestCloseAccountReceived: 'Đã nhận yêu cầu đóng tài khoản',
        errorCancellingClosure: 'Lỗi khi hủy đóng tài khoản',
        requestCancelClosureReceived: 'Đã nhận yêu cầu hủy đóng tài khoản',
    },
    ar: {
        accountDetails: 'تفاصيل الحساب',
        communicationPreferences: 'تفضيلات التواصل',
        paymentPreferences: 'تفضيلات الدفع',
        firstName: 'الاسم الأول',
        lastName: 'اسم العائلة',
        username: 'اسم المستخدم',
        contactEmail: 'البريد الإلكتروني للتواصل',
        mobile: 'الجوال',
        internationalDiallingCode: 'رمز الاتصال الدولي',
        pleaseSelect: 'يرجى الاختيار',
        commsViaWhatsApp: 'أريد استلام الأنشطة لإكمالها عبر واتساب',
        commsViaEmail: 'أريد استلام النشرات الإخبارية والتحديثات عبر البريد الإلكتروني كجزء من {communityName}',
        mobileNumberHint: 'أدخل رقمًا محليًا أو رقمًا دوليًا كاملاً. نقوم بتطبيعه باستخدام رمز الاتصال للبلد المحدد.',
        preferredPaymentMethod: 'طريقة الدفع المفضلة:',
        paymentEmail: 'البريد الإلكتروني للدفع',
        saveChanges: 'حفظ التغييرات',
        viewPaymentRecords: 'عرض سجل المدفوعات',
        paymentRecordsTitle: 'سجل المدفوعات',
        loadingPaymentRecords: 'جارٍ تحميل السجلات',
        paymentsTableTitle: 'المدفوعات',
        errorGettingUserDetails: 'حدث خطأ أثناء جلب تفاصيل المستخدم',
        errorUpdatingProfile: 'حدث خطأ أثناء تحديث الملف الشخصي',
        profileUpdated: 'تم تحديث الملف الشخصي',
        manageAccount: 'إدارة الحساب',
        closeAccountIntro: 'إذا لم تعد ترغب في المشاركة في {communityName}، يمكنك طلب',
        closeAccountLink: 'إغلاق حسابك هنا',
        closeAccountGracePeriod: 'سيكون لديك شهر من تاريخ الطلب لإعادة تفعيل حسابك قبل حذفه.',
        accountDueToClose: 'من المقرر إغلاق حسابك في {date}،',
        cancelClosureLink: 'إلغاء الإغلاق من هنا',
        closeAccountHeader: 'إغلاق حسابك',
        closeAccountConfirmMessage: 'هل أنت متأكد أنك تريد إغلاق حسابك؟',
        closeAccountConfirmButton: 'إغلاق',
        cancel: 'إلغاء',
        errorClosingAccount: 'حدث خطأ أثناء إغلاق الحساب',
        requestCloseAccountReceived: 'تم استلام طلب إغلاق الحساب',
        errorCancellingClosure: 'حدث خطأ أثناء إلغاء إغلاق الحساب',
        requestCancelClosureReceived: 'تم استلام طلب إلغاء إغلاق الحساب',
    },
};
